(function($) {
	var $lookbook = $('.lookbook');

	// Sets height of aside nav to match
	var prevLookbookHeight = $lookbook.height();

	function setListHeight() {
		var newHeight = $lookbook.height();

		if (prevLookbookHeight != newHeight) {
			$('.lookbook__list').height($lookbook.height());

			$(document.body).trigger('sticky_kit:recalc');

			prevLookbookHeight = $lookbook.height();
		}
	}

	function resizeImage(image, size) {
		var pattern = /\.(jpg|jpeg|png|gif)\?/;
		var url = image.replace(pattern, '_' + size + '.$1?');

		return url;
	}

	function init() {
		var $micro = $('#microtrends').html();
		var $material = $('#materials').html();

		function scrollNav() {
			setListHeight();

			$lookbook.chapters({
				nav: '.lookbook__list',
				header: '.lookbook__microtrend--title',
				subHeader: 'h3',
			});
		}

		function makeSlick($images) {
			$images.slick({
				infinite: true,
				dots: true,
				arrows: false,
				speed: 600,
				autoplay: true,
			});
		}
		function buildProduct(product) {
			return `
					<figure class="product-card">
						<img data-src="${product.image.src}" src="" alt="${
				product.title
			} | Mazzucchelli 1849" data-pin-no-hover="true" data-pin-description="${
				product.title
			} | Mazzucchelli 1849">
					</figure>
			`;
		}
		function getMaterials(articles) {
			var ids = [];

			// Loop through articles and grab IDs
			for (id in articles) {
				if (articles.hasOwnProperty(id)) {
					var subArticles = articles[id].articles;

					for (subArticle in subArticles) {
						if (subArticles.hasOwnProperty(subArticle)) {
							ids.push(subArticles[subArticle].id);
						}
					}
				}
			}
			Relatable.get(
				{
					query: 'article.articles',
					id: ids.join(','),
				},
				function(subArticles) {
					for (collecId in subArticles) {
						collec = subArticles[collecId];
						if (collec.articles.length > 1) {
							// console.log({ collecId });
							let domElemContainer = document.querySelectorAll(
								`[data-id='${collecId}']`
							);
							let domElem = domElemContainer[0].querySelectorAll(
								'.collections-multiple'
							)[0];
							collec.articles.forEach((subId, index) => {
								let subCollecTitle = document.createElement('section');
								subCollecTitle.innerHTML = `<h4>${subId.title}</h4>`;
								domElem.insertAdjacentElement('afterbegin', subCollecTitle);

								Relatable.get(
									{
										query: 'article.products',
										id: subId.id,
									},
									function(article) {
										article[subId.id].products.forEach((product) => {
											let output = buildProduct(product);
											let dom = document.createElement('a');
											dom.href = `/products/${product.handle}`;
											dom.innerHTML = output;
											subCollecTitle.insertAdjacentElement('beforeend', dom);
										});
									}
								);
							});
						}
					}
				}
			);

			Relatable.get(
				{
					query: 'article.products',
					id: ids.join(','),
				},
				function(articles) {
					for (id in articles) {
						if (articles.hasOwnProperty(id)) {
							article = articles[id];
							let collectionName = [];
							let productType = '';
							// Do this because for whatever reason IE doens't like mustache
							// methods
							for (product in article.products) {
								var _p = article.products[product];
								// console.log({ _p });
								// console.log(_p.product_type);
								productType = _p.product_type.split(' - ')[0];
								if (!collectionName.includes(`${productType}`)) {
									collectionName.push(`${productType}`);
								}
								var url = resizeImage(_p.image.src, 'medium');

								article.products[product].image_url = url;
							}
							// console.log({ collectionName });
							// console.log({ id });
							var output = Mustache.render($material, articles[id]);
							var $html = $.parseHTML(output);
							// console.log(output);

							$('[data-id="' + id + '"]')
								.find('.materials')
								.html($html);
						}
					}
				}
			);
		}

		function articleImages(article) {
			for (a in article.articles) {
				if (article.articles.hasOwnProperty(a)) {
					var _article = article.articles[a];
					_article.image = resizeImage(_article.image.src, '1024x1024');
					_article.images = [];

					for (meta in _article.metafields) {
						var metafield = _article.metafields[meta];
						var value = metafield.value;

						if (
							_article.metafields.hasOwnProperty(meta) &&
							value.trim() != ''
						) {
							if (metafield.namespace == 'images') {
								// Do this because for whatever reason IE doens't like mustache
								// methods

								var url = resizeImage(value, '1024x1024');

								_article.images.push(url);
							} else if (metafield.key == 'attachment') {
								_article.attachment = value;
							}
						}
					}
				}
			}

			return article;
		}

		function getMicroTrends(ids) {
			// Get all micro trends
			Relatable.get(
				{
					query: 'article.articles',
					id: ids,
				},
				function(articles) {
					for (id in articles) {
						if (articles.hasOwnProperty(id)) {
							var output = Mustache.render($micro, articleImages(articles[id]));
							var $html = $.parseHTML(output);

							var $macrotrend = $(
								'.lookbook__macrotrend[data-id="' + id + '"]'
							);
							var $header = $macrotrend.find('.macrotrend-header');
							var $microtrends = $macrotrend.find('.microtrends');

							$microtrends.html($html);

							makeSlick($microtrends.find('.images'));
						}
					}

					// Get get materials
					getMaterials(articles);

					// scroll nav
					scrollNav();
				}
			);
		}

		getMicroTrends(Shopify.article_ids);
	}

	Relatable.ready(function() {
		$(function() {
			init();
		});
	});

	function loadImages() {
		// Get all images below screen
		var $images = $lookbook.find('img[data-src]').filter(function() {
			// Bottom of the browser
			var bottom = $(window).height() + $(window).scrollTop();
			var offset = 100;

			var inView = $(this).offset().top < bottom + offset;

			if (inView && $(this).attr('src') != $(this).data('src')) {
				$(this).attr('src', $(this).data('src'));
			}
		});
	}

	$(window).resize(setListHeight);

	var throttleScroll;

	$(window).scroll(function() {
		clearTimeout(throttleScroll);

		throttleScroll = setTimeout(function() {
			// Lazy load images
			loadImages();

			// Set sidebar height for sticky kit
			setListHeight();
		}, 100);
	});
})(jQuery);

document.addEventListener('DOMContentLoaded', function(e) {
	let ArchiveVipCustomerFalse = document.getElementById(
			'ArchiveVipCustomerFalse'
		),
		archiveOutletProducts = '';
	console.log({ ArchiveVipCustomerFalse });
	if (ArchiveVipCustomerFalse) {
		archiveOutletProducts = ArchiveVipCustomerFalse.children;
		// console.dir(ArchiveVipCustomerFalse.children.length);
		// console.log({ archiveOutletProducts });
		for (let i = 0; i < archiveOutletProducts.length; i++) {
			console.dir(archiveOutletProducts[i]);
		}
	}
});
